import Video from './Video';
import useVideoEvents from './hooks/useVideoEvents';
import Scenes from './features/Scenes';
import VideoRouter from './features/VideoRouter';
import Tracking from './features/Tracking';
import Subtitles from './features/Subtitles';
import Fullscreen from './features/Fullscreen';

const VideoWrapper = () => {
    const { onVideoReady, onVideoPlay, onVideoPause, onVideoTimeUpdate, onVideoEnd } = useVideoEvents();

    return (
        <>
            <Video
                onVideoReady={onVideoReady}
                onVideoPlay={onVideoPlay}
                onVideoPause={onVideoPause}
                onVideoTimeUpdate={onVideoTimeUpdate}
                onVideoEnd={onVideoEnd}
            />
            <Scenes />
            <VideoRouter />
            <Tracking />
            <Subtitles />
            <Fullscreen />
        </>
    )
}

export default VideoWrapper;
